module.exports = __webpack_public_path__ + "img/serve_01@2x.45e8abe5.png";